module.exports = __webpack_public_path__ + "html/success-stories-list_67e27b139a5e5af19e8d8ff3b12da19a.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/success-stories-list.html
// module id = jKm6
// module chunks = 49